<mat-card class="cardWithShadow theme-card">
    <mat-card-header>
        <mat-card-title>Información Fogape</mat-card-title>
        <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>
        <table class="table table-bordered text-center">
         <tr>
            <th>Propiedad</th>
            <th>Valor</th>
         </tr>
         <tr>
            <th>Deuda UF</th>
            <th>{{fogapeInfo?.globalDebt}}</th>
         </tr>
         <tr>
            <th>Restricciones</th>
            <th>{{fogapeInfo?.hasRestriction ? 'Sí' : 'No'}}</th>
         </tr>
         <tr>
            <th>PYME</th>
            <th>{{fogapeInfo?.isPyme ? 'Sí'  : 'No'}}</th>
         </tr>
         <tr>
            <th>Observaciones</th>
            <th>{{fogapeInfo?.observation}}</th>
         </tr>
        </table>
    </mat-card-content>
</mat-card>